import script from "./EntityButton.vue?vue&type=script&setup=true&lang=js"
export * from "./EntityButton.vue?vue&type=script&setup=true&lang=js"

import "./EntityButton.vue?vue&type=style&index=0&id=3783d40f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3783d40f"]])

export default __exports__